RadioInput = createReactClass
  displayName: 'RadioInput'

  render: ->
    <input {...@props} type="radio" />

module.exports = RadioInput
